/**
 * @desc 根据店铺标识查找应用账号信息
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.AppAccountResponseRpcDto>;
export function request(
  params: API.basics.platformSiteShopFacadeImpl.getAppAccountByShopKey.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/platformSiteShop/getAppAccountByShopKey`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
